// import { ITask } from '@remote/type'

export const Title = '迅雷盒子'
export const TAB_DOING = 'DOING'
export const TAB_DOING_NAME = '下载中'
export const TAB_DONE = 'DONE'
export const TAB_DONE_NAME = '已完成'
export const USER_RUNNER = 'user#runner' // 远程设备
export const USER_DOWNLOAD = 'user#download' // 远程下载
export const USER_DOWNLOAD_URL = 'user#download-url' // 远程云添加
export const TASK_RUNNING = 'PHASE_TYPE_PENDING,PHASE_TYPE_RUNNING,PHASE_TYPE_ERROR,PHASE_TYPE_PAUSED' // 进行中的任务
export const TASK_COMPLETE = 'PHASE_TYPE_COMPLETE' // 完全和结束的任务
export const TASK_TYPE_IDS = ['ing', 'done', 'file']
export const TASK_TYPE = {
  'ing': TASK_RUNNING,
  'done': TASK_COMPLETE,
}

export const SPEC_TXT = {
  'running': '启动',
  'pause': '暂停',
  'delete': '删除',
}

export const IS_FIRST = 'device_pan_is_first'
export const DEVICE_LAST_ID = 'device_pan_last_id'

export const MAX_DEVICE_ONLINE_NUM = 3

export const DOWNLOAD_URL = 'http://mobile.xunlei.com/m/channel.html?from=qunhui_remote_dl'
export const DOWNLOAD_URL_IOS = 'https://oia-pan-ssl.xunlei.com/?from=qunhui_remote_dl'
export const MIN_IOS_VERSION_CODE = 125 // APP要求版本 1.2.5
export const THE_VERSION_CODE = 13441 // APP要求版本

export const SUPPORT_SHORTCUT_CODE = 14210 // 安卓app支持快捷方式的版本
export const SUPPORT_REQUEST_CODE = 13700 // 安卓app支持新请求方法的版本
export const SUPPORT_VIDEO_PLAY_CODE = 13660 // 安卓app支持云播api的版本

export const MAX_URL_ADD_NUM = 50


const ua = navigator.userAgent
const UA_IOS_REG = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/
const isIOS13Pad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

const UA_ANDROID_REG = /\bAndroid([^;]+)/
const UA_WX_REG = /MicroMessenger/
const UA_WEIBO_REG = /\bWeibo/
const UA_QZONE_REG = /Qzone\//

export const isAndroid = UA_ANDROID_REG.test(ua)
export const isWeibo = UA_WEIBO_REG.test(ua)
export const isQzone = UA_QZONE_REG.test(ua)
export const isWx = UA_WX_REG.test(ua)
export const isIOS = UA_IOS_REG.test(ua) || isIOS13Pad

export const DEVICE_NAME_MAP = new Map([
  ['pan.xunlei.cli', '群晖'],
  ['pan.xunlei.cli.lexar', '雷克沙'],
  ['pan.xunlei.cli.synology', '群晖'],
  ['pan.xunlei.cli.ubuntu', 'Ubuntu'],
  ['pan.xunlei.cli.hiksemi', '海康'],
  ['pan.xunlei.cli.ugreen', '绿联'],
  ['pan.xunlei.cli.lenovo', '联想'],
  ['pan.xunlei.cli.xcloud', '迅雷私有云'],
  ['pan.xunlei.cli.macos', 'MacOs'],
  ['pan.xunlei.cli.raspbian', '树莓派'],
  ['pan.xunlei.cli.linux', 'linux'],
  ['pan.xunlei.cli.zspace', '极空间'],
  ['pan.xunlei.cli.docker', 'Docker'],
])

// 错误信息映射文案
export const ERROR_DESC_MAP = {
  'internal':  '请稍后重试', // '内部服务错误'
  'no such file': '文件不存在，请核对后重试', // '/drives/disk_a1/Users/admin/Downloads/迅雷下载/*****:no such file or   directory'
  'unknown': '未知错误', // not found
  'not found': '请稍后重试', // not found
}

export const AuthorizeLogout = {status:'success', info: '退出成功', type: 'logout'}
export const AuthorizeLogin = {status:'success', info: '登录成功', type: 'login'}
export const AuthorizeFail = {status:'fail', info: '登录失败', type: 'login'}
export const AuthorizeCancel = {status:'cancel', info: '取消登录', type: 'login'}
export const AuthorizeInvalid = {status:'invalid', info: '授权码链接过期', type: 'login'}

export const LOGIN_FEEDBACK_URL = 'https://new.xlkf.xunlei.com/live800/chatClient/chatbox.jsp?companyID=8950&configID=73&enterurl=ikf.xunlei.com&robot_ud_ikf=ikf'

export const USER_PROTOCOL_URL = 'https://i.xunlei.com/xluser/legal/agreement.html'
export const PRIVACY_PROTOCOL_URL = 'https://pan.xunlei.com/yc/privacy/' // 注意这里最后的斜杠不能去掉。运维配置导致这里斜杠去掉之后会先301到http的带斜杠地址，导致mixed content拦截
export const PAN_PROTOCOL_URL = 'https://pan.xunlei.com/privacy'
export const VIP_PROTOCOL_URL = 'https://vip.xunlei.com/tos.html'

export const CUSTOM_SERVICE_URL = 'https://new.xlkf.xunlei.com/live800/chatClient/chatbox.jsp?companyID=8950&configID=106&enterurl=NAS.xunlei.com&robot_ud_NAS=NAS&chatfrom=NAS'
export const SUBMIT_QUESTION_URL = 'https://ikf.xunlei.com/subDetail?dictid=148'
export const SYNOLOGY_HELP_URL = 'https://nas.xunlei.com/help'

export const EXPIRE_DATE_LIST = [15,7,6,5,4,3,2,1,0]
export const IS_FIRST_SHOW_PLUGIN = 'is_first_show_plugin'
export const USER_PLAY_FILE_SIZE = 1*1024*1024*1024
export const VIP_USER_PLAY_FILE_SIZE = 4*1024*1024*1024

// 厂商
export const LEXAR = 'lexar' // 江波龙
export const DOCKER = 'docker'
export const HIKSEMI = 'hiksemi' // 海康
export const UBUNTU = 'ubuntu'
export const XCLOUD = 'xcloud'
export const MACOS = 'macos'
export const RASPBIAN = 'raspbian'
export const ZSPACE = 'zspace' // 极空间
export const SYNOLOGY = 'synology' // 群晖
export const QNAP = 'qnap' // 威联通
export const UGREEN = 'ugreen' // 绿联
export const TERRAMASTER = 'terramaster' // 铁威马
export const LINUX = 'linux'
export const LENOVO = 'lenovo'
export const HUAWEI = 'huawei'
export const PCXLLITE = 'pcxllite'

/**
 * 支持标准流程的厂商：华为
 * 支持标准流程，即厂商自己实现了页面端对套件端的调用方式。
 */
export const STAND_AUTH_PROCESS_PATH_ENV: PathEnv[] = ['huawei']

/**
 * 过滤的厂商设备缩写: 雷克赛、海康、绿联
 */
export const ExcludePlatforms = [LEXAR, HIKSEMI, UGREEN]

export const SUPPORT_REMOTE_LOGOUT_PLATFORM = ['huawei']

/**
 * 微信小程序关闭路径: 极空间 绿联 lenovo 江波龙 群晖
 */
export const MapMiniProgramHome = {
  [ZSPACE]: '/pages/views/home/index',
  [UGREEN]: '/pages/index/index',
  [LENOVO]: '/pages/views/home/index',
  [LEXAR]: '/pages/views/home/index',
  [SYNOLOGY]: '/pages/views/home/index',
}

/**
 * 继续延用旧版播放方法的厂商
 */
export const OldJumpPlayVideoPlatforms = [LENOVO]

/**
 * 展示小插件的厂商 群辉 威联通 铁威马
 */
export const PluginPlatforms = [SYNOLOGY, DOCKER, QNAP, TERRAMASTER, LINUX, LENOVO, HUAWEI, UGREEN, ZSPACE]

// 迅雷盒子平台
export const XL_BOX_PLATFORM = 'xlbox'

/**
 * 展示添加本地BT文件的厂商 群辉 威联通 铁威马 极空间 海康 绿联
 */
export const UploadBTPlatforms = [SYNOLOGY, DOCKER, QNAP, TERRAMASTER, ZSPACE, UGREEN, HIKSEMI, HUAWEI, LENOVO, PCXLLITE, XL_BOX_PLATFORM]

export const FactoryPathMap = {
  [ZSPACE]: 'jkj',
  [UGREEN]: 'ugreen',
  [LENOVO]: 'lenovo',
  [LEXAR]: 'lex',
  [HIKSEMI]: 'hik',
  [HUAWEI]: 'huawei',
}


/** 客服热线 */
export const HotlineTelNumber = '400-1111-000'

/** 小插件默认banner */
export const defaultPluginImg = 'https://backstage-img-ssl.a.88cdn.com/20ffb36cb407d05fe2a110139865009fbf6d0bd7'

export const DEVICE_STATUS = ['离线', '在线', '连接中...', '重启中...', '升级中...']
export const DEVICE_STATUS_CLASS = ['offline', 'online', 'connecting', 'connecting', 'connecting']
export const SHOW_HEAD_ROUTE_NAME = ['home', 'me', 'cinema', 'heziFiles', 'deviceBind', 'login', 'disks', 'cinemaSearch', 'album', 'albumPath']